export const MANUAL_PAYMENT_METHODS = [
  {
    label: 'Cash',
    value: 'cash',
  },
  {
    label: 'Check',
    value: 'check',
  },
  {
    label: 'Electronic (Venmo, Cashapp, etc)',
    value: 'electronic',
  },
  {
    label: 'Money Order',
    value: 'money_order',
  },
  {
    label: 'Other',
    value: 'other',
  },
  {
    label: 'Refund',
    value: 'refund',
  },
];

export default { MANUAL_PAYMENT_METHODS };
